export default {
  // 区域管理
  insertPaFactoryArea: '/ygsjzs/paFactoryArea/insertPaFactoryArea',
  updatePaFactoryArea: '/ygsjzs/paFactoryArea/updatePaFactoryArea',
  deletePaFactoryArea: '/ygsjzs/paFactoryArea/deletePaFactoryArea',
  selectPaFactoryAreaByAreaId: '/ygsjzs/paFactoryArea/selectPaFactoryAreaByAreaId',
  selectPaFactoryAreaByPage: '/ygsjzs/paFactoryArea/selectPaFactoryAreaByPage',
  // 网格管理
  insertPaFactoryGrid: '/ygsjzs/paFactoryGrid/insertPaFactoryGrid',
  updatePaFactoryGrid: '/ygsjzs/paFactoryGrid/updatePaFactoryGrid',
  deletePaFactoryGrid: '/ygsjzs/paFactoryGrid/deletePaFactoryGrid',
  selectPaFactoryGridByGridId: '/ygsjzs/paFactoryGrid/selectPaFactoryGridByGridId',
  selectPaFactoryGridByPage: '/ygsjzs/paFactoryGrid/selectPaFactoryGridByPage',
  // 检查结果
  insertPaSanitationResult: '/ygsjzs/paSanitationResult/insertPaSanitationResult',
  updatePaSanitationResult: '/ygsjzs/paSanitationResult/updatePaSanitationResult',
  deleteDataPaSanitationResult: '/ygsjzs/paSanitationResult/deleteDataPaSanitationResult',
  selectPaSanitationResultByRecordId: '/ygsjzs/paSanitationResult/selectPaSanitationResultByRecordId',
  selectPaSanitationResultByPage: '/ygsjzs/paSanitationResult/selectPaSanitationResultByPage'
}
